import React from "react";
import { Box, Skeleton } from "@mui/material";
import PropTypes from "prop-types";

const defaultProps = {
  isLoading: false,
};

const SkeletonContainer = ({ children, isLoading, width, height }) => {
  return (
    <Box>
      {isLoading ? (
        <Skeleton sx={{ transform: "none" }} width={width} height={height} />
      ) : (
        children
      )}
    </Box>
  );
};

SkeletonContainer.propTypes = {
  isLoading: PropTypes.bool,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

SkeletonContainer.defaultProps = defaultProps;

export default SkeletonContainer;
